import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsOptional, IsString } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
export class PatchWebMerchantMetadataRewardsScreenDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebMerchantMetadataRewardsScreenDto.prototype, "loyaltyWiki", void 0);
//# sourceMappingURL=PatchWebMerchantMetadataRewardsScreenDto.js.map